export default "__VITE_ASSET__DJoIUFd7__"